import React from "react";
import AccessoriesSectionCard from "../../components/common/Accessories-Section-Card/AccessoriesSectionCard";
import accessoriesproduct1 from "../../assets/img/accessoriesproduct1.png"
import accessoriesproductaddmore from "../../assets/img/accessoriesproductaddmore.png"
import airpodsaccessories from "../../assets/img/airpods-accessories.png"
import Carousel from 'react-bootstrap/Carousel'
import { useSelector } from 'react-redux';
import { FaPlus } from 'react-icons/fa';
import { getSampleCurrencyFormat } from "../../utils/utils";
import "./AccessoriesSection.css";
import { apiHandler } from "../../api";
import { endpoint } from "../../api/endpoint";
import { GET_ACCESS_BANNER } from "../../assets/graphql";
import { useEffect } from "react";
import { useState } from "react";

const AccessoriesSection = () => {
    const { accessories } = useSelector(
        (state) => state.home
    );

    const [bannerhtml,setbannerhtml]=useState('');

    const getBanner = async () => {
		const result = await apiHandler({
			url: endpoint.GRAPHQL_URL,
			method: 'POST',
			data: {
				base_url: endpoint.API_BASE_URL,
				variables: {},
				query: GET_ACCESS_BANNER,
			},
		});
		if (!result.data.error_code) {
            setbannerhtml(result.data && result.data.cmsBlocks && result.data.cmsBlocks.items && result.data.cmsBlocks.items[0].content);
		}
	};

    useEffect(()=>{
        getBanner();
    },[])

    const unescapeHTML = (html) => {
        var escapeEl = document.createElement("textarea");
        escapeEl.innerHTML = html;
        return escapeEl.textContent;
      };

    return (
        <>
        {accessories && accessories.length ? 
        <div className=" mobile-carousel-team-computer mobile-accessories" >
            <section className="productaddsection">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-9 mx-auto text-center py-5">
                            <div className="mainsection-title">
                                <h2>Accessories</h2>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <!-- Desktop View Accessories section --> */}
                <div className="container-fluid d-none d-lg-block d-md-block">
                    <div className="row">

                        <div className="col-md-3 Text-decoration-adbanner-byAirpods"  dangerouslySetInnerHTML={{ __html:unescapeHTML(bannerhtml) }}>
                            {/* <div className="addbanner ">
                                <h4><span> It’s magic,</span> Remastered.</h4>
                                <p>Spatial audio with dynamic head tracking in an all-new design.</p>

                                <a href="/#/product-detail/Airpods">Buy AirPods</a>

                                <img src={airpodsaccessories} className="img-fluid" alt="" />
                            </div> */}
                        </div>

                        <div className="col-md-9">
                            <div className="row">
                                {accessories && accessories.filter((a, i) => i < 5).map((accessory, index) =>
                                    // {index < 5 && (
                                    <div className="col-md-4" key={index}>
                                        <AccessoriesSectionCard id={accessory.sku} PrductImg={accessory.image.url} ProductDetail={accessory.name} ProductPrice={getSampleCurrencyFormat(accessory.price_range.minimum_price.regular_price.currency, accessory.price_range.minimum_price.regular_price.value)} />
                                    </div>
                                )}
                                {/* )} */}

                                {accessories && accessories.length > 5 && (
                                    <>
                                        <div className="col-md-4">
                                            <div className="accessoriesproductbox text-decoration-Browse-more">
                                                <img src={accessoriesproductaddmore} alt="" />
                                                <div className="addmore">
                                                    <a href="/#/accessories-list">
                                                        <i><FaPlus /></i>
                                                        <span>Buy Now</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>

                    </div>
                </div>
                {/* <!-- Desktop View Accessories section END --> */}


                {/* <!-- Mobile View Accessories section --> */}
                <div className="owl-carousel owl-theme circle-slider d-lg-none d-md-none m-3">
                    <Carousel>
                        {accessories && accessories.filter((a, i) => i < 5).map((accessory, index) =>
                            <Carousel.Item key={index}>
                                <div className="item">
                                    <AccessoriesSectionCard id={accessory.sku} PrductImg={accessory.image.url} ProductDetail={accessory.name} ProductPrice={getSampleCurrencyFormat(accessory.price_range.minimum_price.regular_price.currency, accessory.price_range.minimum_price.regular_price.value)} />

                                </div>
                            </Carousel.Item>
                        )}

                    </Carousel>
                </div>
                {/* <!-- Mobile View Accessories section END --> */}
            </section>
        </div>
        :null}
        </>
    )
}
export default AccessoriesSection;